import { render, staticRenderFns } from "./RouteConfigForm.vue?vue&type=template&id=740c1a94&scoped=true"
import script from "./RouteConfigForm.vue?vue&type=script&lang=js"
export * from "./RouteConfigForm.vue?vue&type=script&lang=js"
import style0 from "./RouteConfigForm.vue?vue&type=style&index=0&id=740c1a94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740c1a94",
  null
  
)

export default component.exports